<script setup lang="ts">
import { IonPage, IonRouterOutlet, IonTabs } from '@ionic/vue';
</script>

<template>
  <ion-page class="auth">
    <ion-tabs>
      <ion-router-outlet />
    </ion-tabs>
  </ion-page>
</template>

<style lang="less">
.auth {
  ion-tabs {
    inset-block-start: env(safe-area-inset-top);
  }
}
</style>
